import type MP4Box from 'mp4box';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';
import { hasAudio } from '../hasAudio';

const validateAudioType = (info: MP4Box.Mp4BoxInfo, addError: AddError): void => {
  if (!hasAudio(info)) {
    return;
  }
  const [audioTrack] = info.audioTracks;
  if (!/^mp4a.40/.test(audioTrack.codec)) {
    addError(VALIDATIONS.INVALID_AUDIO_TYPE);
  }
};

export default validateAudioType;
